// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"e352c3c6","925":"482785c7"}[chunkId] + ".chunk.css";
};